import { PitchListHelper } from 'classes/helpers/pitch-list.helper';
import { CommonConfirmationDialog } from 'components/common/dialogs/confirmation';
import usePitchListStore from 'components/sections/pitch-list/store/use-pitch-list-store';
import { ArrayHelper } from 'lib_ts/classes/array.helper';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IPitch } from 'lib_ts/interfaces/pitches';
import { clone } from 'lodash';
import { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import useListLibraryStore from 'stores/use-list-library-store';

interface IProps {
  pitches: IPitch[];
  onDelete: () => void;
}

export const DeletePitchesDialog: FC<IProps> = (props) => {
  return (
    <CommonConfirmationDialog
      identifier="DeletePitchesDialog"
      title="common.delete"
      content={
        <ReactMarkdown
          children={[
            `Are you sure you want to remove the following pitch(es) from this list? **Warning: This cannot be undone.**`,
            PitchListHelper.enumeratePitches(props.pitches, 5),
          ].join('\n\n')}
        />
      }
      action={{
        label: 'common.delete',
        color: RADIX.COLOR.DANGER,
        onClick: async () => {
          const pitchIDs = props.pitches.map((p) => p._id);

          const success = await usePitchListStore
            .getState()
            .deletePitches(pitchIDs);

          if (!success) {
            return;
          }

          setTimeout(() => {
            const toRemove: { bs_hash: string; _parent_id: string }[] = [];

            pitchIDs.forEach((id) => {
              const pitch = props.pitches.find((p) => p._id === id);

              if (!pitch) {
                return;
              }

              toRemove.push({
                bs_hash: pitch.bs_hash,
                _parent_id: pitch._parent_id,
              });
            });

            const toRemoveDict = ArrayHelper.groupBy(toRemove, '_parent_id');

            Object.keys(toRemoveDict).forEach((_parent_id) => {
              const entry = toRemoveDict[_parent_id];

              if (!entry) {
                return;
              }

              const bsHashes = entry.map((entry) => entry.bs_hash);
              const listId = _parent_id;

              useListLibraryStore.setState((prev) => {
                if (bsHashes.length === 0) {
                  // no hashes, no change
                  return prev;
                }

                const nextDict = clone(prev.listSummaryDict);

                const list = nextDict[listId];

                if (!list) {
                  // no list found, no change
                  return prev;
                }

                bsHashes.forEach((hash) => {
                  // a list could have multiple instances of a hash, so only remove one
                  const firstInstance = list.bs_hashes.findIndex(
                    (h) => h === hash
                  );

                  if (firstInstance > -1) {
                    list.bs_hashes.splice(firstInstance, 1);
                    list.total -= 1;
                  }
                });

                return {
                  listSummaryDict: nextDict,
                };
              });
            });
          }, 500);

          props.onDelete();
        },
      }}
    />
  );
};
